'use client';

import { useCart } from '@/lib/cart-store';
import { openCartDrawer } from '@/lib/cart-drawer';

export function HeaderCart() {
  const { count, status } = useCart();
  const showBadge = status !== 'loading' && count > 0;

  // Anchor with onClick — plain click opens the drawer, but cmd/ctrl/middle-click
  // fall through to /cart so power users can still open the full cart in a tab.
  return (
    <a
      href="/cart"
      aria-label="Cart"
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
        e.preventDefault();
        openCartDrawer();
      }}
      className="relative hover:text-ink"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M5 7h14l-1.5 11h-11L5 7z" />
        <path d="M9 7V5a3 3 0 016 0v2" />
      </svg>
      {showBadge && (
        <span
          className="absolute -top-1.5 -right-1.5 bg-ink text-bone text-[9px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center font-numerals tabular-nums leading-none"
          aria-label={`${count} ${count === 1 ? 'item' : 'items'} in cart`}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </a>
  );
}
